import type { ReactNode } from 'react';

import classNames from 'classnames';

import styles from './DialogButtonsWrapper.module.scss';

type Props = {
  children: ReactNode;
  className?: string;
  fullWidth?: boolean;
};

export const DialogButtonsWrapper = ({ className, children, fullWidth = false }: Props) => {
  return (
    <div className={classNames(styles.wrapper, fullWidth && styles.fullWidth, className)}>
      {children}
    </div>
  );
};
